<mat-sidenav-container class="layout-container">
  @if (!hideSidebar()) {
    <mat-sidenav
      #sidenav
      [mode]="isMobile() ? 'over' : 'side'"
      [opened]="sidenavOpened()"
      class="layout-sidebar"
      fixedInViewport="false">
      <app-global-sidebar
        [menuItems]="salaryMenuConfig"
        (itemClick)="isMobile() && sidenav.close()">
      </app-global-sidebar>
    </mat-sidenav>
  }

  <mat-sidenav-content class="layout-content">

    <app-global-header
      moduleTitle="Salary Module"
      [showMenuToggle]="!hideSidebar()"
      (toggleSidebar)="toggleSidenav()">
    </app-global-header>

    <!-- cdkScrollable: this div (not the window) scrolls the page, so open Material overlays
         (autocomplete/select/datepicker panels) must track it to stay attached to their field. -->
    <div class="main-content" cdkScrollable>
      <app-breadcrumb></app-breadcrumb>
      <div class="page-container">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-global-footer></app-global-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
